import { styled } from 'styled-components'
import { mediaDesktop } from './styles/breakPoints'

const Footer = styled.footer`
  background-color: var(--themeColorBackgroundPrimary);
  width: 100%;
  padding: 16px;
  ${mediaDesktop} {
    padding: 32px;
  }
  button + button {
    margin-top: 16px;
  }
`

export default Footer
